"use client" // Error components must be Client Components

import { Button, Image, Text, Title } from "@mantine/core"
import { IconHome } from "@tabler/icons-react"
import { useEffect } from "react"
import { usePostHog } from "posthog-js/react"

import Link from "next/link"
import classes from "./error.module.css"

export default function Error({ error }: { error: Error & { digest?: string } }) {
  const posthog = usePostHog()

  useEffect(() => {
    posthog.captureException(error, {
      nextjs_error_digest: error.digest,
      source: "app_error_boundary",
    })

    if (process.env.NEXT_PUBLIC_POSTHOG_LOGS_ENABLED === "true") {
      posthog.logger.error("app_error_boundary", {
        error_name: error.name,
        error_message: error.message,
        nextjs_error_digest: error.digest,
      })
    }
  }, [error, posthog])

  return (
    <div className={classes.container}>
      <div className={classes.imageContainer}>
        <Title className={classes.errorCode}>500</Title>
        <Image alt="Not Found Logo" h={300} w="auto" fit="contain" src="/assets/error_404.gif" className={classes.image} />
      </div>
      <div className={classes.textContainer}>
        <Title order={3} className={classes.title}>
          Internal Server Error
        </Title>
        <Text className={classes.text} maw={460}>
          Our internal server has gone on a uninformed vacation. And, we are trying our best to bring it back online.
        </Text>
        <Button size={"md"} leftSection={<IconHome size={16} />} component={Link} href="/" className={classes.button}>
          Go home
        </Button>
      </div>
    </div>
  )
}
